export type PersonNameFormat = "first" | "last" | "short" | "full";

export function formatPersonName(
  fullName: string | undefined,
  format: PersonNameFormat = "full",
): string {
  if (!fullName) return "Usuário Desconhecido";

  const parts = fullName.trim().split(" ");
  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : "";

  switch (format) {
    case "first":
      return first;
    case "last":
      return last;
    case "short":
      // Retorna "Nome S." (Ex: Lucas H.)
      return parts.length > 1 ? `${first} ${last.charAt(0)}.` : first;
    case "full":
    default:
      return fullName;
  }
}
